import React, { useContext } from 'react';
import { FormContext } from '../../FormContext';

const InputAddRemove = ({ field_id, field_multiple_id, field_multiple_type }) => {

  const {
    handleAddField,
    handleRemoveLastField,
    formPageType,
    formStatus,
    formElements,
    currentPageIndex,
    formMultipleType,
  } = useContext(FormContext);

  const handleAddButtonClick = () => {
    if (formMultipleType) {
      handleAddField(field_id);
    } else {
      handleAddField(field_id);
    }
  };

  let lastFieldId = null; // Initialize with a default value
  let field_field_multiple_id = null; // Initialize with a default value
  let prop_field_multiple_id = null; // Initial
  

  if (field_multiple_type !== undefined && field_multiple_type === formMultipleType || field_multiple_type == undefined && formMultipleType == undefined) {
    const parts = formElements.pages[currentPageIndex].parts;
    let multiplePrimaryId = null;
    for (const part of parts) {
      for (const field of part.fields) {
        if (field.field_multiple_id === field_multiple_id) {
          if (field.field_multiple_primary === 'yes') {
            multiplePrimaryId = field.field_id;
          }
          lastFieldId = field.field_id;
          field_field_multiple_id = field.field_multiple_id;
          prop_field_multiple_id = field_multiple_id
        }
      }
    }

    if (
      (formPageType === 'user' && field_id === lastFieldId) ||
      (field_id === lastFieldId && formStatus !== 'Submitted')  && field_multiple_id !== undefined
    ) {
      return (
        <div className='mt-3 text-right'>
          {/* <p>field_id {field_id}</p>
          <p>lastFieldId {lastFieldId}</p>
          <p>field_field_multiple_id {field_field_multiple_id}</p>
          <p>prop_field_multiple_id {prop_field_multiple_id}</p> */}
          <u className='text-success mr-3' onClick={handleAddButtonClick} style={{ cursor: 'pointer' }}>
            Add
          </u>
          <u className='text-danger' onClick={() => handleRemoveLastField(field_id)} style={{ cursor: 'pointer' }}>
            Remove
          </u>
        </div>
      );
    }
  } else {
    return null;
    // return (
    //   <div>
    //     <p>field_id {field_id}</p>
    //     <p>lastFieldId {lastFieldId}</p>
    //     <p>field_field_multiple_id {field_field_multiple_id}</p>
    //     <p>prop_field_multiple_id {prop_field_multiple_id}</p>
    //     <p>field_multiple_id {field_multiple_id}</p>
    //   </div>
    // );
  }

  return null;

};

export default InputAddRemove;